
// RemoveCategory.tsx - Modern confirmation modal for removing categories
import React, { useState } from 'react';
import { Modal, Button } from 'react-bootstrap';
import { X } from 'react-bootstrap-icons';
import { toast } from 'react-toastify';
import { removeMenuCategoryFromMenu } from '../../../../../../../../../../crud/menu_api/menus';
import MiniLoadingSpinner from '../../../../../../../../../../components/Spinners/MiniLoadingSpinner';
import './RemoveCategory.scss';

 
/* ======================= RenderRemoveCategoryModal ======================= */
const RemoveCategory: React.FC<any> = ({
  show,
  handleClose,
  menu,
  category,
  setSelectedCategory,
  menus,
  setMenus,
  setSelectedMenu,
  onCategoryRemoved, // optional callback
}) => {
    const [loading, setLoading] = useState(false);

  const handleRemoveCategory = async () => {
    setLoading(true);
    removeMenuCategoryFromMenu(Number(menu?.menu_id), category?.id)
      .then(() => {
        toast.success('Categoría removida exitosamente');
        const updatedCategories = menu?.categories?.filter((c: any) => c.id !== category?.id);
        setSelectedMenu({
          ...menu,
          categories: updatedCategories,
        });
        const updatedMenus = menus.map((m: any) => {
          if (m.menu_id === menu?.menu_id) {
            return { ...menu, categories: updatedCategories };
          }
          return m;
        });
        setMenus(updatedMenus);
        setSelectedCategory(null);
        if (onCategoryRemoved) onCategoryRemoved(category);
        handleClose();
      })
      .catch((error) => {
        console.error('Error deleting menu:', error);
        toast.error('Error al eliminar la categoría');
      }).finally(() => {
        setLoading(false);
      });
  };

  return (
    <Modal show={show} onHide={handleClose} centered className="remove-category-modal">
      <Modal.Header>
        <div className="form-modal-title-container">
          <Modal.Title className="form-modal-title">Quitar Categoría</Modal.Title>
        </div>
        <Button variant="none" className="modal-close-button" onClick={handleClose}>
          <X size={24} />
        </Button>
      </Modal.Header>

      {loading && (
        <div className="loading-overlay">
          <MiniLoadingSpinner />
        </div>
      )}

      {!loading && (
        <Modal.Body>
          <p>
            ¿Estás seguro que deseas remover <strong>{category?.name}</strong> del menú <strong>{menu?.menu_name}</strong>?
          </p>
          
          <div className="explanation-text">
            <p className="explanation-title">
              ¿Qué significa quitar una categoría?
            </p>
            <p>
              • La categoría se <strong>desvinculará</strong> del menú seleccionado<br/>
              • La categoría <strong>no se eliminará permanentemente</strong> del sistema<br/>
              • Podrás <strong>volver a agregarla</strong> a cualquier menú en el futuro<br/>
              • Sus subcategorías y elementos se mantendrán intactos
            </p>
          </div>
        </Modal.Body>
      )}

      <Modal.Footer>
        <Button variant="none" onClick={handleClose} className="form-button-cancel">
          Cancelar
        </Button>
        <Button 
          variant="none" 
          onClick={handleRemoveCategory} 
          className="form-button-remove"
          disabled={loading}
        >
          {loading ? (
            <>
              <span
                className="spinner-border spinner-border-sm"
                role="status"
                aria-hidden="true"
              />{' '}
              Quitando...
            </>
          ) : (
            'Quitar'
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default RemoveCategory;

